export default __webpack_public_path__ + "static/media/home.7fc4253e.png";